import * as types from './types';

export default {
    [types.UPDATE_BLINK_CARD_INFO](state, params) {
        Object.assign(state.blinkCardSubject, params);
        if (params.host) {
            state.host = params.host;
        }
    },
};
